import Vue from 'vue'
import Vuex from 'vuex'

import initSiteStore from './store/SiteStore.js'

Vue.use(Vuex)

const defaultState = {
  count: 0,
  ENV_PROD : process.env.NODE_ENV === 'production',
  ENV_DEV : process.env.NODE_ENV === 'development',
}

const inBrowser = typeof window !== 'undefined'

// if in browser, use pre-fetched state injected by SSR
const state = (inBrowser && window.__INITIAL_STATE__) || defaultState

const getters = {

}
const mutations = {
  increment (state) {
    state.count++
  }
}
const actions = {
  increment (state) {
    state.count++
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})

initSiteStore(store)

export default store
